import EditVacancyButton from 'domain/recruiting/vacancy/shared/button/EditVacancyButton';
import {
  CREATE_VACANCY,
  DISPLAY_UPDATE_BUTTON,
  UPDATE_VACANCY,
  UPDATE_VACANCY_MANAGER,
} from 'domain/recruiting/vacancy/shared/vacancyService';
import CopyVacancyButton from 'domain/recruiting/vacancy/shared/button/CopyVacancyButton';
import DeleteVacancyButton from 'domain/recruiting/vacancy/shared/button/DeleteVacancyButton';
import PublishVacancyButton from 'domain/recruiting/vacancy/shared/button/PublishVacancyButton';
import ViewVacancyPageMenu from 'domain/recruiting/vacancy/Show/ViewVacancyPageMenu';
import SingleVacanciesBreadcrumbs from 'domain/recruiting/vacancy/shared/SingleVacanciesBreadcrumbs';
import VacancyEntityHeader from 'domain/recruiting/vacancy/shared/VacancyEntityHeader';
import React from 'react';
import { ShowPageLayout } from 'framework/ui/layout';
import EditVacancyManagerButton from 'domain/recruiting/vacancy/shared/button/EditVacancyManagerButton';
import MigrateVacancyButton from 'domain/recruiting/vacancy/shared/button/MigrateVacancyButton';

type ShowVacancyPageLayoutProps = {
  children: React.ReactElement[] | React.ReactElement;
};

const ShowVacancyPageLayout = ({ children }: ShowVacancyPageLayoutProps) => {
  return (
    <ShowPageLayout
      headerButtons={[
        <EditVacancyManagerButton
          key="edit-manager"
          icon={<i className="fa fa-profile" />}
          permissionToCheck={UPDATE_VACANCY_MANAGER}
        />,
        <EditVacancyButton key="edit-vacancy" icon={<i className="fa fa-edit" />} permissionToCheck={UPDATE_VACANCY} />,
        <CopyVacancyButton key="copy-vacancy" permissionToCheck={CREATE_VACANCY} />,
        <DeleteVacancyButton key="delete-vacancy" />,
        <PublishVacancyButton
          isVisible={vacancy => vacancy.status === 'OPEN'}
          source="alias"
          key="publish-vacancy"
          permissionToCheck={DISPLAY_UPDATE_BUTTON}
        />,
        <MigrateVacancyButton key="migrate-vacancy" />,
      ]}
      menu={<ViewVacancyPageMenu />}
      breadcrumbs={<SingleVacanciesBreadcrumbs />}
      entityHeader={<VacancyEntityHeader />}
      hasSeparateSections
    >
      {children}
    </ShowPageLayout>
  );
};

export default ShowVacancyPageLayout;
